import { useMatterType } from "../../../contexts/MatterTypeContext";
import { TableCell, TableRow } from "../../../design/table";
import { Matter } from "../../../models/Matter";
import moment from "moment";

interface MatterListItemProps {
  matter: Matter;
}
const MatterListItem: React.FC<MatterListItemProps> = ({ matter }) => {
  const { matterTypes } = useMatterType();
  return (
    <TableRow key={matter._id} href={`/matter/${matter._id}`}>
      <TableCell>{matter.name}</TableCell>
      <TableCell>
        {matterTypes.find((type) => type._id === matter.matterType)?.name}
      </TableCell>
      <TableCell>{matter.users?.map((user) => user.name).join(", ")}</TableCell>
      <TableCell>
        {moment(matter.updatedAt).format("YYYY-MM-DD HH:mm")}
      </TableCell>
    </TableRow>
  );
};

export default MatterListItem;
